// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0664c8fb","84":"73da226d","95":"66169a73","113":"7ae34644","177":"50d27305","233":"0f52994b","261":"c1eabf2d","277":"28277830","278":"ddef7507","401":"b4636288","453":"6dfbd809","590":"726a21f2","773":"367b5cb5","813":"04917aa9","834":"da44ac7e","848":"471c8607"}[chunkId] + ".chunk.js";
};